export default function normaliseLanguage(language) {
  var replaced = language.replace('_', '-');
  var split = replaced.split('-');
  if (split.length < 2) {
    return language;
  }
  return "".concat(split[0], "-").concat(split[1].toUpperCase());
}